import React from "react";
//import { Row , Container, Col} from "react-bootstrap";
import InfoItem from "./InfoItem";
import './appInfoDivCss.css';
import { useTranslation } from 'react-i18next';
/*import info1Image from '/data/appData/appImages/infoPhoto/info1.jpg'
import info2Image from '/data/appData/appImages/infoPhoto/info2.jpg'
import info3Image from '/data/appData/appImages/infoPhoto/info3.jpg'
import info4Image from '/data/appData/appImages/infoPhoto/info4.jpg'*/

function Info(){
    const { t } = useTranslation();

    //let modePaiementDescription = "Carte bancaire à partir de 15€" ;
    //let qualityDescription ="Notre restaurant vous proposent des repas vriés, préparés soigneusement pour répondre à votre gôut et à vos attentes. Consommées sur place, emportées ou livrées, vos commandes sont traitées par une equipe de professionnels compétents.";
    //let halalDescription="Nous vous proposons une variété de petits déjeuné servis sur place ou à emporter tous les jours entre 7h à 14h   ";
/*
    let evals = [
        [ star5, "Le 2024-04-10 18:52:00 Nadia", "Restaurant très classe. Les plats sont très délicieux. A recommander" ],
        [ star5, "Le 2024-01-22 22:22:25 Abdelali", "Espace très agréable pour se détendre et manger des bons plats." ],
        [ star5, "Le 2024-07-06 16:23:00 Anas", "Très bon. je recommande" ],
        [ star5, "Le 2023-06-17 17:20:35 Khadija", "C'est le meilleur resto de meknes. Un très bon espace pour se détendre et déguster des bons plats" ],
    ]*/
    return(
            <div>
                <InfoItem title={t("Excelence")} image={"/data/appData/appImages/infoPhoto/info1.jpg"}  description={""} isEvaluation={false} evals={[[]]}></InfoItem>
                <InfoItem title={t("Carisma")} image={'/data/appData/appImages/infoPhoto/info2.jpg'}  description={""} isEvaluation={false} evals={[[]]}></InfoItem>
                <InfoItem title="Performance" image={'/data/appData/appImages/infoPhoto/info3.jpg'}  description={""} isEvaluation={false} evals={[[]]}></InfoItem>
                <InfoItem title={t("Elegance")} image={'/data/appData/appImages/infoPhoto/info4.jpg'}  description={""} isEvaluation={false} evals={[[]]}></InfoItem>
                
            </div>
            


        
    );

}

export default Info